import { Platform } from '@/utils/platform';
import { invoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';

export const getPeopleInfo = async (data: { popoid: string; yxuid: number }) => {
  const temp = {
    popo_id: data.popoid,
    yxuid: data.yxuid,
  };
  // console.log(`call : data=${JSON.stringify(temp)}`);
  let avatarUrl = '';
  let name = '';
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      const res: { data: { url: string; PeopleName: string } } = await invoke(
        'GetPeopleInfo',
        temp
      );
      avatarUrl = res.data.url;
      name = res.data.PeopleName;
    } else {
      const res: { url: string; PeopleName: string } = await call('GetPeopleInfo', temp);
      avatarUrl = res.url;
      name = res.PeopleName;
    }
  }
  // console.log(`response: res=${JSON.stringify(res)}`);
  return {
    avatarUrl: avatarUrl,
    name: name,
  };
};
